module.exports = __webpack_public_path__ + "static/Sato-7d916ef5fb14dd71546a38b35c9313a2.png";